import { Component, OnInit } from '@angular/core';
import { UpsertCustomerRequest } from '../../WebApiClient';
import { CustomerService } from '../../services/customer.service';
import { Guid } from '../../models/Guid';

@Component({
    selector: 'app-create-customer',
    templateUrl: './create-customer.component.html',
    styleUrls: ['./create-customer.component.scss', '../../style/crudFloat.scss'],
    standalone: false
})
export class CreateCustomerComponent implements OnInit {

    public customer: UpsertCustomerRequest;

    constructor(
        private readonly customerService: CustomerService
    ) {
        this.customer = this.newCustomer();
    }

    ngOnInit(): void {
    }

    create() {
        if (!this.isInputValid)
            return;
        let o = this.customerService.upsert(this.customer);
        o.toPromise().then(_ => this.customer = this.newCustomer());
        return o;
    }

    get isInputValid(): boolean {
        return this.customerService.isValid(this.customer);
    }

    private newCustomer(): UpsertCustomerRequest {
        const result = new UpsertCustomerRequest({ id: Guid.newGuid(), name: "" });
        return result;
    }
}
